import { useApi } from "../hooks/useApi";
import type { CommandCenterSnapshot } from "../api/types";

export function LiveStrip() {
  const { data: snap } = useApi<CommandCenterSnapshot>("/command-center/snapshot");
  if (!snap) return null;

  const alerts = snap.alertmanager?.firing ?? 0;
  const errors = snap.loki?.errors_1h;
  const deploys = snap.jenkins?.total ?? 0;
  const crashFree = snap.crashlytics?.crash_free_rate;

  return (
    <div className="live-strip visible">
      <Pill cls={alerts > 0 ? "crit" : "ok"}>
        {alerts === 0 ? "No firing alerts" : `${alerts} firing alert${alerts === 1 ? "" : "s"}`}
      </Pill>
      {crashFree != null && (
        <Pill cls="ok">{`Mobile crash-free ${crashFree}%`}</Pill>
      )}
      {errors != null && (
        <Pill cls={errors > 1000 ? "warn" : "ok"}>{`${errors} errors / 1h`}</Pill>
      )}
      {deploys != null && (
        <Pill cls="ok">{`${deploys} deploys 24h`}</Pill>
      )}
    </div>
  );
}

function Pill({ cls, children }: { cls: "ok" | "warn" | "crit"; children: React.ReactNode }) {
  return <span className={`live-pill ${cls}`}><span className="dot" />{children}</span>;
}
